import React from 'react'
import styled from 'styled-components'
import { TABLET, DESKTOP, MEDIUM, REGULAR } from '@streamr/streamr-layout/styled'
import { Button } from '@streamr/streamr-layout'
import node from './assets/node.png'
import node2x from './assets/node@2x.png'
import sponsor from './assets/sponsor.png'
import sponsor2x from './assets/sponsor@2x.png'
import delegator from './assets/delegator.png'
import delegator2x from './assets/delegator@2x.png'
import bounty from './assets/bounty.png'
import bounty2x from './assets/bounty@2x.png'
import publisherApp from './assets/publisher_app.png'
import publisherApp2x from './assets/publisher_app@2x.png'
import stakePool from './assets/stake_pool.png'
import stakePool2x from './assets/stake_pool@2x.png'
import Topic from '~shared/Topic'
import Container from '~shared/Container'
import Spacer from '~shared/Spacer'
import ButtonWrapper from '~shared/ButtonWrapper'
import Br from '~shared/Br'
import urls from '~utils/urls'

const Icon = styled.div`
    width: 45px;
    height: 45px;

    img {
        max-width: 60px;
        max-height: 60px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media (min-width: ${TABLET}px) {
        width: 50px;
        height: 50px;
    }

    @media (min-width: ${DESKTOP}px) {
        width: 80px;
        height: 80px;

        img {
            max-width: 100px;
            max-height: 100px;
        }
    }
`

const Title = styled.h3`
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: ${MEDIUM};
    margin: 0;

    @media (min-width: ${DESKTOP}px) {
        font-size: 1.25rem;
        line-height: 1.875rem;
    }
`

const Description = styled.p`
    font-size: 0.75rem;
    line-height: 1.25rem;
    margin: 0;

    @media (min-width: ${DESKTOP}px) {
        font-size: 1.125rem;
        line-height: 1.875rem;
    }
`

const Card = styled.div`
    background-color: #FAFAFA;
    border-radius: 4px;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 16px 0 128px;
    position: relative;

    ${Icon} {
        position: absolute;
        left: 40px;
        top: 50%;
        transform: translateY(-50%);
    }

    @media (min-width: ${TABLET}px) {
        min-height: 144px;
        padding: 0 16px 0 120px;
    }

    @media (min-width: ${DESKTOP}px) {
        min-height: 240px;
        padding: 0 48px 0 232px;

        ${Icon} {
            left: 80px;
        }
    }
`

const Column = styled.div`
    ${Card} + ${Card} {
        margin-top: 1rem;
    }

    @media (min-width: ${TABLET}px) {
        ${Card} + ${Card} {
            margin-top: 2rem;
        }
    }
`

const Columns = styled.div`
    ${Column} {
        flex: 1;
    }

    ${Column} + ${Column} {
        margin-top: 1rem;
    }

    @media (min-width: ${TABLET}px) {
        display: flex;
        flex-direction: row;

        ${Column} + ${Column} {
            margin-left: 2rem;
            margin-top: 0;
        }
    }
`

const DocsLink = styled.div`
    text-align: center;

    h3 {
        font-size: 1.25rem;
        font-weight: ${REGULAR};
        line-height: 2rem;
        margin: 0;
        margin-bottom: 2.5rem;
    }

    @media (min-width: ${TABLET}px) {
        h3 {
            font-size: 1.5rem;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        h3 {
            font-size: 1.625rem;
        }
    }
`

const UnstyledRolesAndEntities = (props) => (
    <Topic {...props}>
        <Container>
            <Columns>
                <Column>
                    <Card $appear>
                        <Icon>
                            <img src={node} srcSet={`${node2x} 2x`} alt="Broker" />
                        </Icon>
                        <Title>Broker</Title>
                        <Description>
                            Mine Bounty smart contracts
                            <br />
                            by staking $DATA and relaying
                            <br />
                            incentivised streams
                        </Description>
                    </Card>
                    <Card $appear>
                        <Icon>
                            <img src={sponsor} srcSet={`${sponsor2x} 2x`} alt="Sponsor" />
                        </Icon>
                        <Title>Sponsor</Title>
                        <Description>
                            Provides funds in $DATA to
                            <br />
                            incentivise streams. Can be
                            <br />
                            same entity as Publisher.
                        </Description>
                    </Card>
                    <Card $appear>
                        <Icon>
                            <img src={delegator} srcSet={`${delegator2x} 2x`} alt="Delegator" />
                        </Icon>
                        <Title>Delegator</Title>
                        <Description>
                            Provides funds in $DATA to
                            <br />
                            selected Stake Pools. Earns yield
                            <br />
                            from Bounties via node rewards
                        </Description>
                    </Card>
                </Column>
                <Column>
                    <Card $appear>
                        <Icon>
                            <img src={bounty} srcSet={`${bounty2x} 2x`} alt="Bounty" />
                        </Icon>
                        <Title>Bounty</Title>
                        <Description>
                            Smart contract deployed
                            <Br tablet desktop />
                            by Sponsor
                            <Br mobile />
                            containing
                            <Br tablet desktop />
                            funds in $DATA
                        </Description>
                    </Card>
                    <Card $appear>
                        <Icon>
                            <img src={publisherApp} srcSet={`${publisherApp2x} 2x`} alt="Publisher App" />
                        </Icon>
                        <Title>Publisher App</Title>
                        <Description>
                            Publishes streams to the
                            <Br tablet desktop />
                            Network
                            <Br mobile />
                            to be relayed by
                            <Br tablet desktop />
                            Broker Nodes
                        </Description>
                    </Card>
                    <Card $appear>
                        <Icon>
                            <img src={stakePool} srcSet={`${stakePool2x} 2x`} alt="Stake Pool" />
                        </Icon>
                        <Title>Stake Pool</Title>
                        <Description>
                            Smart contract containing $DATA
                            <br />
                            that allows Brokers to join streams
                        </Description>
                    </Card>
                </Column>
            </Columns>
            <Spacer as={DocsLink} head="3.75rem,7.5rem,9rem">
                <h3 $appear>
                    Dive into the Tokenomics
                    <Br mobile />
                    docs to learn more
                </h3>
                <ButtonWrapper>
                    <Button
                        tag="a"
                        kind="primary"
                        size="big"
                        href={urls.docs.dataToken}
                    >
                        Tokenomics docs
                    </Button>
                </ButtonWrapper>
            </Spacer>
        </Container>
    </Topic>
)

const RolesAndEntities = styled(UnstyledRolesAndEntities)`
    ${Container} {
        padding: 0 1rem;
    }

    @media (min-width: ${TABLET}px) {
        ${Container} {
            max-width: 44rem;
            padding: 0;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Container} {
            max-width: 72.5rem;
        }
    }
`

export default RolesAndEntities
